import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4835 2.17026C11.7727 1.89562 12.2263 1.89536 12.5158 2.16967C14.5319 4.07976 17.2532 5.24911 20.25 5.24911H20.402C20.726 5.24911 21.0133 5.4571 21.1145 5.76484C21.527 7.01948 21.75 8.35952 21.75 9.75011C21.75 15.6926 17.6863 20.6832 12.1869 22.0984C12.0643 22.13 11.9356 22.13 11.813 22.0984C6.31373 20.6822 2.25 15.6916 2.25 9.74911C2.24898 8.39616 2.46346 7.05168 2.88541 5.76621C2.98769 5.45462 3.28055 5.24561 3.60847 5.25018C6.53492 5.29103 9.36128 4.18565 11.4835 2.17026ZM12.0005 3.72184C9.80566 5.58939 7.03907 6.65657 4.15614 6.74526C3.88602 7.72263 3.74918 8.73286 3.75 9.74851C3.75 14.9225 7.24249 19.2824 12.0001 20.5959C16.7575 19.2833 20.25 14.9241 20.25 9.75011C20.25 8.70762 20.1083 7.69925 19.8437 6.74276C16.8565 6.64927 14.1274 5.52866 12.0005 3.72184Z"
        fill={colorValue}
      />
      <path
        d="M12.0002 7.11556C14.8154 7.11556 12.0002 15.4844 12.0002 15.4844C12.0002 15.4844 9.185 7.11556 12.0002 7.11556Z"
        fill={colorValue}
      />
      <path
        d="M12 16.2368C11.5858 16.2368 11.25 16.5726 11.25 16.9868V16.9948C11.25 17.409 11.5858 17.7448 12 17.7448H12.008C12.4222 17.7448 12.758 17.409 12.758 16.9948V16.9868C12.758 16.5726 12.4222 16.2368 12.008 16.2368H12Z"
        fill={colorValue}
      />
    </svg>
  );
};
